export default [
    { id: 'blank', value: 'Open in new window' },
    { id: 'modal', value: 'Open in modal' },
];
